import React, { useEffect, useState } from "react";
import { Card, Table, Row, Col, Statistic, Typography } from "antd";
import { ReportServices } from "../../Services/Reports/ReportServices";

const getPermission = (link) => {
  try {
    const raw = localStorage.getItem("ome_permission");
    const parsed = JSON.parse(raw);
    const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
    return permissions.find(p => p.link === link) || { add: false, edit: false, delete: false, read: false };
  } catch { return { add: false, edit: false, delete: false, read: false }; }
};


const PlReport = ({ apiData }) => {

  const perm = getPermission('/finance/reports/p-l');

  const [incomeSummary, setIncomeSummary] = useState([]);
  const [expenseSummary, setExpenseSummary] = useState([]);
  const [totals, setTotals] = useState({
    income: 0,
    expense: 0,
    profit: 0,
  });

  // Extract dynamic pay modes from object keys
  const extractPayModes = (obj) => {
    if (!obj) return [];

    return Object.keys(obj).map((key) => ({
      mode: key,
      inflow: Number(obj[key]?.inflow_amount || 0),
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await ReportServices.getAllFinReport();
      if (!response?.data) return;

      const { poPayReport, proPayReport, billPayReport, payReport } =
        response.data;

      // Income sources = payReport
      const income = extractPayModes(payReport);

      // Expense sources = PO + Project + Bill
      const expense = [
        ...extractPayModes(poPayReport),
        ...extractPayModes(proPayReport),
        ...extractPayModes(billPayReport),
      ];

      // Group expense by mode
      const expenseGrouped = Object.values(
        expense.reduce((acc, item) => {
          acc[item.mode] = acc[item.mode] || { mode: item.mode, inflow: 0 };
          acc[item.mode].inflow += item.inflow;
          return acc;
        }, {})
      );

      // Calculate totals
      const totalIncome = income.reduce((s, x) => s + x.inflow, 0);
      const totalExpense = expenseGrouped.reduce((s, x) => s + x.inflow, 0);

      setIncomeSummary(income);
      setExpenseSummary(expenseGrouped);
      setTotals({
        income: totalIncome,
        expense: totalExpense,
        profit: totalIncome - totalExpense,
      });
    };

    fetchData();
  }, [apiData]);

  const columns = [
    { title: "Mode", dataIndex: "mode", key: "mode" },
    { title: "Amount", dataIndex: "inflow", key: "inflow" },
  ];

 if (!perm.read) {
    return (
      <div style={{ padding: 20 }}>
        <Typography.Text type="secondary">You don't have permission to view this page.</Typography.Text>
      </div>
    );
  }

  return (
    <div style={{ padding: 20 }}>
      <Row gutter={20}>
        <Col span={8}>
          <Card>
            <Statistic title="Total Income" value={totals.income} />
          </Card>
        </Col>

        <Col span={8}>
          <Card>
            <Statistic title="Total Expense" value={totals.expense} />
          </Card>
        </Col>

        <Col span={8}>
          <Card>
            <Statistic
              title="Total Profit"
              value={totals.profit}
              valueStyle={{ color: totals.profit >= 0 ? "green" : "red" }}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={20} style={{ marginTop: 30 }}>
        <Col span={12}>
          <Card title="Income Summary (Quotation/ Invoice)">
            <Table
              columns={columns}
              dataSource={incomeSummary}
              pagination={false}
              rowKey="mode"
            />
          </Card>
        </Col>

        <Col span={12}>
          <Card title="Expense Summary (PO + Project + Bill)">
            <Table
              columns={columns}
              dataSource={expenseSummary}
              pagination={false}
              rowKey="mode"
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PlReport;
